import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { Outlet } from 'react-router-dom';
import { Suspense, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { useSmartNavigationData } from '~/apps/smartsend/components/onboarding/hooks/use-smart-navigation-data';
import DesktopTitledLayout from './desktop-layout';
import MobileLayout from './mobile-layout';
import Navvy from './navvy';

// My Orders area (account experience). Two tabs reusing the existing order lists, with
// the SmartSend underline tab style (Navvy) and an InTransit count badge. No new
// functionality (no status filter / per-order actions) - that's deferred.
const routes = [RoutingConstants.OrderHistory, RoutingConstants.InTransit];

export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { t } = useTranslation(TranslationNamespaces.MYACCOUNT);
  const { bookedCount, inTransitCount } = useSmartNavigationData();

  const labels = useMemo(
    () => ({
      [RoutingConstants.OrderHistory]: t('ACCOUNT_ORDERS_TAB_MY_ORDERS', { defaultValue: 'My Orders' }),
      [RoutingConstants.InTransit]: t('ACCOUNT_ORDERS_TAB_IN_TRANSIT', { defaultValue: 'Orders in Transit' })
    }),
    [t]
  );

  const counts = useMemo(
    () => ({
      [RoutingConstants.OrderHistory]: bookedCount,
      [RoutingConstants.InTransit]: inTransitCount
    }),
    [bookedCount, inTransitCount]
  );

  if (isXs) {
    return (
      <MobileLayout>
        <Outlet />
      </MobileLayout>
    );
  }

  return (
    <DesktopTitledLayout title={t('ACCOUNT_ORDERS_AREA_TITLE', { defaultValue: 'My Orders' })}>
      <Suspense>
        <Navvy routes={routes} prefix="ACCOUNT_ORDERS" counts={counts} labels={labels} />
      </Suspense>
      <Outlet />
    </DesktopTitledLayout>
  );
}

Component.displayName = 'My Orders';
